import * as types from './types';
import { updateApplication } from "./applicationActions";

export const updatePTRequirementsInfo = (updates) => {
  return {
    type: types.UPDATE_PT_REQUIREMENTS_INFO,
    updates
  }
};

export const savePTRequirementsInfo = (education, ptRequirements) => {
  return updateApplication( { education, ptRequirements });
};